/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  FaClipboardList,
  FaTruck,
  FaHome,
  FaBars,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { useColorMode } from "@chakra-ui/react";
import "./BottomNavbar.css";
import { useSuperAdminPermissions } from "../../../hooks/useSuperAdminPermissions";
export default function BottomNavbar({ setIsOpen }) {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const navigate = useNavigate();
  const location = useLocation();
  const { colorMode } = useColorMode();

  // Get user permissions from localStorage
  
  const perms = useSuperAdminPermissions();

  // Define bottom nav items with permissions
  const bottomNavItems = [
    {
      path: "/admin/plans",
      icon: <FaClipboardList />,
      label: t("admin.plans"),
      permission: "viewAdminPlansPage"
    },
    {
      path: "/admin/shipping",
      icon: <FaTruck />,
      label: t("admin.shipping"),
      permission: "viewAdminShipping"
    },
    {
      path: "/admin",
      icon: <FaHome />,
      label: t("admin.dashboard"),
      permission: "viewAdminDashboard"
    },
  ];

  // Filter items based on permissions
  const visibleItems = bottomNavItems.filter(item => 
    !item.permission || perms[item.permission]
  );

  return (
    <div
      className={`bottom-navbar ${colorMode === "dark" ? "dark" : "light"} ${
        isArabic ? "rtl" : "ltr"
      }`}
    >
      {visibleItems.map((item, index) => (
        <div
          key={index}
          className={`bottom-item ${
            location.pathname === item.path ? "active" : ""
          }`}
          onClick={() => navigate(item.path)}
        >
          {item.icon}
          <span>{item.label}</span>
        </div>
      ))}

      <div className="bottom-item" onClick={() => setIsOpen(true)}>
        <FaBars />
        <span>{t("admin.menu")}</span>
      </div>
    </div>
  );
}
